/**
 * @module utils/columnSort/fromQB/buildCompareUserGroup
 * @description 场景 1：从 QB 构建对照组前缀列
 */

import type { IColumnSortItem } from '@/pages/datalab/pages/Multidimensional/Analysis/types/chartSettings/fieldColumnSort';
import {
  createCompareUserGroupColumn,
  shouldShowCompareUserGroup,
} from '../untils/compareUserGroup';

export function buildCompareUserGroupItems(
  columnUserFilters: unknown[] | undefined,
  hasUserFilters?: boolean,
): IColumnSortItem[] {
  if (!shouldShowCompareUserGroup(columnUserFilters, hasUserFilters)) {
    return [];
  }
  return [createCompareUserGroupColumn()];
}
